export function FakeConsent() {
    const code = `
(function () {
  function writeConsent(action, categories) {
    var payload = encodeURIComponent(JSON.stringify({ action: action, categories: JSON.stringify(categories) }));
    document.cookie = "CookieScriptConsent=" + payload + "; path=/";
  }
  function dispatch(action) {
    var evt = new Event(action === "accept" ? "CookieScriptAccept" : "CookieScriptReject");
    window.dispatchEvent(evt);
  }

  // Create fake CookieScript object for development
  window.CookieScript = {
    instance: {
      show: function() {
        // Re-show the banner if it was closed
        var existing = document.getElementById('fake-consent');
        if (!existing) {
          createBanner();
        }
      }
    }
  };

  // Allow presetting via ?consent=accept|reject or localStorage("fakeConsent")
  var params = new URLSearchParams(location.search);
  var preset = params.get("consent") || localStorage.getItem("fakeConsent");
  if (preset === "accept" || preset === "reject") {
    console.log("Applying preset fake consent:", preset);
    writeConsent(preset, preset === "accept" ? ["performance", "targeting", "functionality"] : []);
    dispatch(preset);
    return;
  }

  // If already set, do nothing
  if (document.cookie.indexOf("CookieScriptConsent=") !== -1) return;

  function createBanner() {
    var bar = document.createElement("div");
    bar.setAttribute("id", "fake-consent");
    bar.setAttribute("style",
      "position:fixed;left:0;right:0;bottom:0;padding:40px 16px;background:#222;color:#fff;" +
      "display:flex;gap:8px;align-items:center;justify-content:space-between;z-index:2147483647;" +
      "font:24px/1.4 system-ui, -apple-system, Segoe UI, Roboto, Arial"
    );

    var text = document.createElement("div");
    text.textContent = "Local Dev Cookie Banner (fake)";
    bar.appendChild(text);

    function makeBtn(label) {
      var b = document.createElement("button");
      b.textContent = label;
      b.setAttribute("style",
        "border:0;border-radius:8px;padding:8px 12px;cursor:pointer;background:#fff;color:#111;margin-left:12px"
      );
      return b;
    }

    var actions = document.createElement("div");
    var accept = makeBtn("Accept");
    var reject = makeBtn("Reject");
    actions.appendChild(accept);
    actions.appendChild(reject);
    bar.appendChild(actions);

    accept.addEventListener("click", function () {
      writeConsent("accept", ["performance", "targeting", "functionality"]);
      dispatch("accept");
      bar.remove();
    });

    reject.addEventListener("click", function () {
      writeConsent("reject", []);
      dispatch("reject");
      bar.remove();
    });

    document.body.appendChild(bar);
  }

  function ready(fn){ 
    if (document.readyState !== "loading") fn(); 
    else document.addEventListener("DOMContentLoaded", fn); 
  }

  ready(function () {
    createBanner();
  });
})();`;

    return <script dangerouslySetInnerHTML={{ __html: code }} />;
}
